const label = "mb-1 block text-sm font-medium text-foreground/70";

const wrapper = "w-full";

const error = "mb-4 rounded-md bg-destructive/10 px-4 py-2 text-sm text-destructive";

const relative = "relative";

const selectPadding = "pl-9";

export { label, wrapper, error, relative, selectPadding };
